module.exports = __webpack_public_path__ + "static/img/3.9155525.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/3.jpg
// module id = ihpy
// module chunks = 0